import React from "react";
import {
  ShieldCheck,
  UserCheck,
  Sparkles,
  Cpu,
  Gift,
  MapPin,
} from "lucide-react";

const ITEMS = [
  {
    icon: UserCheck,
    title: "Profesyonel Ekip",
    desc: "Alanında uzman, deneyimli ve sürekli eğitim alan profesyonellerle çalışıyoruz.",
  },
  {
    icon: Sparkles,
    title: "Kişiye Özel İşlem Planı",
    desc: "Detaylı analiz sonrası size özel hazırlanan bakım protokolleri uygulanır.",
  },
  {
    icon: ShieldCheck,
    title: "Hijyenik ve Konforlu Ortam",
    desc: "Yüksek sterilizasyon standartları ve ferah uygulama odaları.",
  },
  {
    icon: Cpu,
    title: "Gelişmiş Cihaz Teknolojileri",
    desc: "Sektörün en güncel cihazları ile en etkili sonuçlara ulaşıyoruz.",
  },
  {
    icon: Gift,
    title: "Ücretsiz Ön Görüşme",
    desc: "Karar vermenize yardımcı olmak için ücretsiz deneme ve danışmanlık.",
  },
  {
    icon: MapPin,
    title: "Ümraniye'de Kolay Ulaşım",
    desc: "Merkezi konumu ve kolay ulaşım imkanlarıyla zaman kazandırır.",
  },
];

export default function WhyIona() {
  return (
    <section
      id="neden-iona"
      data-testid="why-iona-section"
      className="iona-section bg-white"
    >
      <div className="iona-container">
        <div className="max-w-2xl mb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-[#5E2A84] mb-4">
            — Neden İONA?
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] leading-[1.1] tracking-tight">
            Güzelliğinize değer veren <span className="italic text-[#5E2A84]">premium yaklaşım</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={item.title}
                data-testid={`why-item-${i}`}
                className="group flex flex-col"
              >
                <div className="w-14 h-14 rounded-2xl bg-[#F4F1F9] flex items-center justify-center text-[#5E2A84] mb-5 group-hover:bg-[#5E2A84] group-hover:text-white transition-colors duration-500">
                  <Icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-xl text-[#1A1A1A] mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
